import { createRequestAction } from '~/utils/create-action/create-action';
import getCurrentDirname from '~/utils/get-current-dirname/get-current-dirname';

const prefix = getCurrentDirname(__dirname);

export const getAvailableRoles = createRequestAction(
  `${prefix}/GET_AVAILABLE_ROLES`
);
